import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { useLang } from "./LanguageContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { t } = useLang();
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("zejzen_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("zejzen_cart", JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    if (items.some((i) => i.id === product.id)) {
      toast.error(t("alreadyInCart"));
      return;
    }
    setItems((prev) => [...prev, product]);
    toast.success(`${product.name} ${t("addedToCart")}`);
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const total = useMemo(() => items.reduce((s, i) => s + i.price, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
